import React from 'react'
import styled, { css } from 'styled-components'
import { Spinner } from './Spinner'
import { Borders, Colors, Fonts, FontWeights } from '../constants'

type Props = React.ComponentProps<typeof Button> & {
  error?: boolean
}

export function MegaButton(props: Props) {
  const isDisabled = props.error || props.disabled
  return <Button {...props} disabled={isDisabled} />
}

type ConfirmButtonProps = Props & { sending: boolean; text?: string }

export function ConfirmButton(props: ConfirmButtonProps) {
  return (
    <MegaButton {...props} disabled={props.disabled || props.sending}>
      {props.sending ? (
        <>
          Awaiting confirmation... <Spinner />
        </>
      ) : (
        props.text || 'Confirm'
      )}
    </MegaButton>
  )
}

const errorStyles = css`
  &:disabled {
    color: ${Colors.White};
    border: 1px solid #d47777;
    background: rgb(212, 119, 119);
    background: linear-gradient(0deg, rgba(212, 119, 119, 1) 0%, rgba(146, 47, 47, 1) 100%);
    cursor: default;
  }
`

const Button = styled.button<{ error?: boolean }>`
  display: block;
  margin: 0 auto;
  width: 100%;
  max-width: 400px;
  height: 50px;
  color: ${Colors.White};
  font-size: 20px;
  font-family: ${Fonts.Header};
  font-weight: ${FontWeights.Bold};
  text-transform: uppercase;
  outline: none;
  cursor: pointer;
  border: 1px solid #94a3b7;
  border-radius: ${Borders.Radius};
  background: rgb(61, 68, 82);
  background: linear-gradient(0deg, rgba(61, 68, 82, 1) 0%, rgba(75, 89, 117, 1) 100%);
  transition: background 2s ease-in;

  &:hover {
    background: linear-gradient(0deg, rgba(40, 59, 100, 1) 0%, rgba(57, 74, 106, 1) 100%);
  }

  &:active {
    background: linear-gradient(0deg, rgba(57, 74, 106, 1) 0%, rgba(27, 47, 83, 1) 100%);
  }

  &:disabled {
    color: ${Colors.LightestGray};
    cursor: not-allowed;
    background: rgb(158, 164, 177);
    background: linear-gradient(0deg, rgba(158, 164, 177, 1) 0%, rgba(90, 94, 103, 1) 100%);
  }

  ${(props) => props.error && errorStyles}
`
